import { Divider } from "../../components/Divider";
import { TROK0 } from "./TROK0";
import construction from 'url:../../assets/pardon-our-dust.png';

export function TROKC() {
    return <div className='trok-main-width v-box gap-32'>
        <div className='trok-main'>
            <h3>This Page is Under Construction.</h3>
            <h3>Please Check Back Later.</h3>
            <br />
            <Divider />
            <br />
            <img src={construction} width='100%' className="trok-box" />
            <br />
            <Divider />
            <br />
        </div>
    </div>
}